import '@/app/globals.css'
import '@/styles/debate/tokens.css'
import '@/styles/debate/fonts.css'
import '@/styles/debate/motion.css'
import '@/styles/debate/components.css'
import '@/styles/debate/stage.css'
import '@/styles/incident/base.css'
import '@/styles/incident/graph.css'
import '@/styles/operator/picker.css'
import '@/styles/operator/chrome.css'
import '@/styles/zeiss/base.css'
import React from 'react'
import Head from 'next/head'
import { StoreProvider } from '@/stores/store-provider'
import { loadRuntimeConfig } from '@/lib/runtime-config'
import type { AppProps } from "next/app";
import { Poppins } from 'next/font/google'
import initializeStore from '@/stores/stores';

const poppins = Poppins({ weight: '400', subsets: ['latin'] });

export default function App({ Component, pageProps }: AppProps) {

  const store = React.useMemo(() => initializeStore(), []);

  // Gate first render on the runtime config (backend base + avatar identities),
  // so consumers that read it at render — getAvatar1/2, getApiBase — always see
  // real values rather than defaults. The load is memoized and never rejects
  // (same-origin fallback), so this resolves quickly even if /api/config fails.
  const [configReady, setConfigReady] = React.useState(false);
  React.useEffect(() => {
    let alive = true;
    void loadRuntimeConfig().finally(() => {
      if (alive) setConfigReady(true);
    });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <>
      <Head>
        <link rel="icon" href="/favicon.ico" />
        <link rel="manifest" href="/manifest.json" crossOrigin="use-credentials" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        <title>Frank Reply DE | Digital Human</title>
      </Head>
      <main className={`${poppins.className} h-screen overflow-hidden`}>
        <StoreProvider store={store}>
          <div className="w-full h-full">
            {configReady ? (
              <Component {...pageProps} />
            ) : (
              // Brief placeholder while config loads (dark, to avoid a flash).
              <div style={{ position: 'fixed', inset: 0, background: '#04060a' }} />
            )}
          </div>
        </StoreProvider>
      </main>
    </>
  )
}